import {FORM} from '../../../../../js/constants/form-types';
import Button from '../../../../ui/button/Button';

export default function formShell(type) {
    var obj = {
        titleForm: type === "edit" ? "Modifier l'enveloppe" : 'Créer une enveloppe',
        subTitleForm: `Veuillez compléter les champs ci-dessous pour ${type === "edit" ? "modifier":  "créer"} votre enveloppe`,
        langSelect: false,
        drawerType: 'drawer',
        noForm: true,
        component: Button,
        textButtonValidate: type === "edit" ? "Modifier" : 'Créer',
        formConfig: {
            type: FORM,
            children:[
                {
                    labelName: 'Principal',
                    isOptionnal: false,
                    optionsInputs:[
                        {
                            type: 'text',
                            label: 'Code',
                            helper: {
                                text: "Code unique de l'enveloppe",
                                link: false,
                            },
                            required: true,
                            disabled: type === "edit",
                            stateName: 'shellName',
                        },
                        {
                            type: 'text',
                            label: 'Libellé',
                            helper: {
                                text: "Nom de l'enveloppe",
                                link: false,
                            },
                            required: true,
                            stateName: 'shellPrettyName',
                        },
                        {
                            type : 'select',
                            label: 'Affichage par défaut',
                            stateName : 'shellView',
                            translated: false,
                            helper: {
                                text: '',
                                link: false,
                            },
                            value: [
                                { value: 'card', label: 'Cards' },
                                { value: 'table', label: 'Tableau' },
                            ]
                        },
                        {
                            type : 'switch',
                            label:'Pagination',
                            helper: {
                                text: 'Voulez-vous activer la pagination ?',
                                link: false,
                            },
                            required: true,
                            stateName: 'shellPagination',
                        },
                        {
                            type : 'switch',
                            label:'Point d\'API sécurisé',
                            helper: {
                                text: 'Utiliser un point sécurisé ?',
                                link: false,
                            },
                            required: true,
                            stateName: 'shellIsSecure',
                        },
                        {
                            type : 'number',
                            label:'Nombre d\'élèments par pages',
                            helper: {
                                text: 'Indiquez le nombre d\'élèments à afficher par page',
                                link: false,
                            },
                            required: true,
                            stateName: 'shellPerPage',
                            conditional : {
                                conditions : [
                                    {
                                        key : 'shellPagination',
                                        value : true
                                    },

                                ]
                            }
                        }
                    ]
                },
            ]
        }
    }
    return obj;
}